import type { Amenity } from "libs/codegen/property-onboarding";
import { useFormController } from "../form/useFormController";

export const useAmenitiesHandler = () => {
    const { value, setValue, fieldState } = useFormController("amenities", {
        defaultValue: [],
        rules: {
            validate: {
                atLeastThree: () => true,
            },
        },
    });

    const handleToggleAmenity = (amenity: Amenity) => {
        // if found value in an array, then exclude it
        if (value.find((a) => a.id === amenity.id)) setValue(value.filter((a) => a.id !== amenity.id));
        else setValue([...value, amenity]);
    };

    return {
        notification: (fieldState.error?.type === "atLeastThree" ? "error" : value.length < 3 ? "notice" : undefined) as
            | "notice"
            | "error"
            | undefined,
        activeIds: value.map((a) => a.id),
        handleToggleAmenity,
    };
};
